import React from 'react';

function Check2(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M20.2467 4.75761C20.5186 4.97018 20.5667 5.36297 20.3542 5.63493L9.72606 19.232C9.27448 19.8097 8.39978 19.808 7.95054 19.2284L3.65602 13.688C3.44455 13.4152 3.49428 13.0226 3.76709 12.8112C4.03991 12.5997 4.4325 12.6494 4.64397 12.9222L8.84012 18.3357L19.3693 4.86513C19.5819 4.59317 19.9747 4.54503 20.2467 4.75761Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Check2;
